/* istanbul ignore file */
import useSWRMutation from 'swr/mutation';
import { useSession } from '@packages/utilities';
import { useIntl } from 'react-intl';
import type { SelectedService } from '../../atoms';
import { addBranchToOrderUrlPath } from '../../helpers';

type Key = [string, string];

export type AddToBasketArgs = {
  sku: string;
  count: number;
  // TODO(api-layer): check if still necessary
  basketOption: Array<Record<string, any>>;
  serviceLineitems: Array<SelectedService>;
  isSpecialOrder: boolean;
  trackingParameter?: {
    source?: string;
    breadcrumbs?: Array<string>;
  };
};

type AddToBasketResponse = {
  success: boolean;
  successMessages: { elements: Array<{ description: string; level: string }> };
  newPLIs: Array<string>;
  size: number;
  subTotal: { currencyCode: string; value: number };
};

// TODO(api-layer): delete unnecessary fetcher and use generated types after resolver are available in api-layer
const addToBasket =
  (locale: string) =>
  (
    [url, token]: Key,
    {
      arg,
    }: {
      arg: AddToBasketArgs;
    },
  ): Promise<AddToBasketResponse> =>
    fetch(url, {
      method: 'PUT',
      headers: { 'x-ec-token': token, 'ec-locale': locale, 'Content-Type': 'application/json' },
      body: JSON.stringify(arg),
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`Put in basket error: Status ${res.status}: ${res.statusText}`);
      }
      return res.json();
    });

export const useAddToBasket = () => {
  const { locale } = useIntl();
  const { jwtToken } = useSession();
  const {
    trigger,
    data: cartData,
    error,
    isMutating,
  } = useSWRMutation(
    jwtToken ? [addBranchToOrderUrlPath('/api/checkout/v1/'), jwtToken] : null,
    addToBasket(locale),
  );

  return { trigger, cartData, error, isMutating };
};
